// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3HRwL","amount":"Amount_amount__1eQWg","tip":"Amount_tip__2jHnL","tipHeader":"Amount_tipHeader__MQZvb","tipsWrap":"Amount_tipsWrap__3Ysc0"};